// @flow
/**
 * отменяет ошибки, нужен чтобы react-intl не заполнял консоль ошибками при смене локали.
 * @returns {null} нул
 */
export function cancelError() {
    return null;
}
